import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConcernProvider } from './contexts/ConcernContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import LandingPage from './pages/LandingPage/LandingPage';
import LoginPage from './pages/LoginPage/LoginPage';
import ClientDashboard from './pages/ClientDashboard/ClientDashboard';
import EngineerDashboard from './pages/EngineerDashboard/EngineerDashboard';
import SubmitConcern from './pages/SubmitConcern/SubmitConcern';
import MyConcerns from './pages/MyConcerns/MyConcerns';
import PendingReviews from './pages/PendingReviews/PendingReviews';
import AllConcerns from './pages/AllConcerns/AllConcerns';
import AddClientUser from './pages/AddClientUser/AddClientUser';
import './App.css';
import ProjectSelection from './pages/ProjectSelection/ProjectSelection';
import AddProject from './pages/AddProject/AddProject';
import InProgressConcerns from './pages/InProgress/InProgress';
import AuditLogs from './pages/Auditlogs/Auditlogs';
import Showroom from './pages/Showroom/Showroom';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';

function App() {
  return (
    <ConcernProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes - no protection needed */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/showroom" element={<Showroom/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/about" element={<About/>}/>
            {/* Client-only routes */}
            <Route 
              path="/client-dashboard" 
              element={
                <ProtectedRoute requiredRole="client">
                  <ClientDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/submit-concern" 
              element={
                <ProtectedRoute requiredRole="client">
                  <SubmitConcern />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-concerns" 
              element={
                <ProtectedRoute requiredRole="client">
                  <MyConcerns />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/select-project" 
              element={
                <ProtectedRoute requiredRole="client">
                  <ProjectSelection />
                </ProtectedRoute>
              } 
            />

            {/* Engineer-only routes */}
            <Route 
              path="/engineer-dashboard" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <EngineerDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/pending-reviews" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <PendingReviews />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/all-concerns" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <AllConcerns />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/add-client" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <AddClientUser />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/add-project" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <AddProject />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/in-progress" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <InProgressConcerns />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/audit-logs" 
              element={
                <ProtectedRoute requiredRole="engineer">
                  <AuditLogs />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </ConcernProvider>
  );
}

export default App;